import { useMemo } from "react";
import { View } from "react-native";
import combineHexColor from "src/helpers/combineHexColor";
import usePalette from "src/hooks/usePalette";
import { radiusLarge } from "src/styles/radius";
import { paddingLarge, paddingSmallSpacer, paddingSpacer } from "src/styles/spacing";
import { GatheringHeaderProps } from "../../types";
import GatheringHeaderEndSection from "../GatheringHeaderEndSection";
import GatheringHeaderName from "../GatheringHeaderName";
import GatheringHeaderRowActions from "../GatheringHeaderRowActions";
import GatheringHeaderWideMiniCards from "./components/GatheringHeaderWideMiniCards";
import GatheringHeaderWideThumbnail from "./components/GatheringHeaderWideThumbnail";

const GatheringHeaderWide = ({
	wheelData,
	renderWheelItem,
	thumbnailUrl_1x1,
	name,
	renderName,
	renderRowActions,
	renderEndSection,
	wheelDataLoading,
	wideOptions: { horizontalPadding = paddingSmallSpacer } = {},
	testID,
	renderThumbnailOverlay,
	hideRowActions,
	miniCards,
}: Omit<GatheringHeaderProps<any>, "variant">) => {
	const { secondary } = usePalette();
	const backgroundColor = useMemo(
		() =>
			combineHexColor({
				hexBase: secondary,
				hexManipulate: "#222222",
				weight: 0.15,
			}),
		[secondary],
	);

	return (
		<View
			testID={testID}
			style={{
				width: "100%",
				flexDirection: "row",
				paddingTop: paddingSpacer,
				paddingHorizontal: horizontalPadding,
			}}
		>
			<View
				style={{
					flex: 1,
					backgroundColor,
					borderRadius: radiusLarge,
					flexDirection: "row",
					overflow: "hidden",
				}}
			>
				<GatheringHeaderWideThumbnail
					wheelData={wheelData}
					renderWheelItem={renderWheelItem}
					thumbnailUrl_1x1={thumbnailUrl_1x1}
					wheelDataLoading={wheelDataLoading}
					renderThumbnailOverlay={renderThumbnailOverlay}
					containerStyle={{
						marginRight: CenterPadding,
					}}
				/>
				<View
					style={{
						marginLeft: CenterPadding,
						flex: 1,
						justifyContent: "center",
					}}
				>
					<GatheringHeaderName name={name} renderName={renderName} />
					{!!miniCards && (
						<GatheringHeaderWideMiniCards
							miniCards={miniCards}
							backgroundColor={backgroundColor}
						/>
					)}
					{!!renderRowActions && (
						<GatheringHeaderRowActions
							variant="Wide"
							renderRowActions={renderRowActions}
							hideRowActions={hideRowActions}
						/>
					)}
					{!!renderEndSection && (
						<GatheringHeaderEndSection
							variant="Wide"
							renderEndSection={renderEndSection}
						/>
					)}
				</View>
			</View>
		</View>
	);
};

const CenterPadding = paddingLarge;

export default GatheringHeaderWide;
